// Which day the "Find times" picker opens on, and when it may move.
//
// The board card is slim: it carries the task's original message but not the
// thread. Read from the card alone, "I hope to find a day next week" put the
// picker on Monday, and the "Tuesday, after 2" that arrived with the full
// thread a moment later never moved it (seen live, Fri Oct 23). So the day is
// chosen only once the thread is loaded, follows a newer patient message, and
// stays put once staff have set it by hand.
import { dayLabel } from './offerSteps';
import { nextBookableDate } from './nextBookableDate';

export interface PickerDateState {
  /** The full task, with its thread, has arrived. */
  threadLoaded: boolean;
  /** The window key the day was last chosen for; null before the first choice. */
  settledFor: string | null;
  /** The window the thread asks for now ('' when it names no day). */
  windowKey: string;
  /** Staff have set the day themselves. */
  dateTouched: boolean;
}

export function shouldSettlePickerDate(s: PickerDateState): boolean {
  if (!s.threadLoaded || s.dateTouched) return false;
  return s.settledFor !== s.windowKey;
}

const inputValue = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** One line under the day saying where it came from, or '' when it needs none. */
export function pickerDateNote(args: {
  windowStart: Date | null | undefined;
  date: string;
  workingDays: string[] | undefined | null;
}): string {
  const { windowStart, date, workingDays } = args;
  if (!windowStart) return '';
  const asked = inputValue(windowStart);
  if (date === asked) return `${dayLabel(date)} is the day the patient asked for.`;
  if (date === nextBookableDate(windowStart, workingDays, true)) {
    return `The patient asked for ${dayLabel(asked)}; ${dayLabel(date)} is the next day this provider works.`;
  }
  return '';
}
